var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.invitationToken)?_c('sign-up-from-invitation-form'):_c('sign-up-form',{attrs:{"additional-required-fields":_vm.additionalRequiredFields(),"show-commercial-offer":_vm.commercialOffer(),"show-newsletter":_vm.newsletter()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }